import React from "react";
import UniThumbGridBox from "../university/components/uni_thumb_grid_box";
import BannerBox from "./components/banner_box";
import TopRankUniCard from "@modules/study/common/top_rank_uni_card";
import { getAssets } from "@unisearch/helpers";
import styles from "./explore_uni_list.module.scss";

export const ExploreUniList = ({ countryWiseUniversity, topUniData }) => {
  const data = countryWiseUniversity;

  let courseCount = 0;
  data?.university?.forEach((uni, i) => {
    courseCount = courseCount + uni.courses.length;
  });

  return (
    <>
      <section className={styles.section_uni_list}>
        <div className="">
          <div className={styles.wrapper}>
            {/* <div className={styles.banner_wrapper}>
              <BannerBox
                image={
                  data?.country?.featuredImage?.src ||
                  getAssets("assets/images/country/country-01.png")
                }
                title={data?.country?.name}
                university={data?.university?.length}
                courses={courseCount}
              />
            </div> */}

            {topUniData?.length > 0 && (
              <div className={styles.uni_box_wrapper}>
                {topUniData?.map((item, i) => (
                  <TopRankUniCard key={i} data={item} />
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ExploreUniList;
